import { Spacing } from "@lattice/design-tokens";

/** Extra clearance beyond Recharts' measured tick width. The library default
 * is 5px, which crowds full timestamp labels on sparse intraday series. */
export const CHART_X_AXIS_MIN_TICK_GAP = Spacing["4xl"];
